import { FC, Fragment } from 'react'
import { UploadedVisualsSection } from '../common/UploadedVisualsSection.component'

import { AssignmentRendererProps } from './AssignmentRenderer.types'
import { AssignmentAddonsSection } from './shared/AssignmentAddonsSection.component'
import { ProductListingSection } from './shared/ProductListingSection.component'

export const PhotoEditingDetailsRenderer: FC<AssignmentRendererProps> = ({ assignment, order, mainProductId }) => {

  return (
    <Fragment>
      <ProductListingSection products={assignment.products} />

      <AssignmentAddonsSection assignment={assignment} order={order} mainProductId={mainProductId} />

      <UploadedVisualsSection assignmentId={assignment.id} />
    </Fragment>
  )
}
